<script setup>

    import { computed } from 'vue'
    import VueDatePicker from '@vuepic/vue-datepicker'
    import '@vuepic/vue-datepicker/dist/main.css'
    import { util } from '@/Helpers'
    import moment from 'moment'
    import { CalendarIcon } from '@heroicons/vue/24/outline'

    const props = defineProps({
        modelValue: {
            required: true
        },
        minDate: {
            type: [String, null],
            default: null
        },
        maxDate: {
            type: [String, null],
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        teleport: {
            type: [String, Boolean],
            default: false
        },
        clearable: {
            type: [String, Boolean],
            default: false
        },
        textInput: {
            type: Boolean,
            default: false
        }
    })

    const emit = defineEmits(['update:modelValue'])

    const internalValue = computed({
        //Since we set the eastern timezone in util. Moment will first parse the date in UTC and then convert to eastern timezone
        //We add 23:59:59 to preserve the date so VueDatePicker can pick up the correct day
        get: () => props.modelValue ? moment(`${props.modelValue} 23:59:59`).toDate() : null,
        set: (value) => emit('update:modelValue', value ? util.date.toDateString(value) : null),
    })

</script>

<template>
    <div>
        <VueDatePicker
            v-model="internalValue"
            :min-date="props.minDate ? new Date(props.minDate + 'T00:00:00') : null"
            :max-date="props.maxDate ? new Date(props.maxDate + 'T00:00:00') : null"
            :enable-time-picker="false"
            week-start="0"
            :autoApply="true"
            :teleport="props.teleport"
            :disabled="props.disabled"
            :clearable="props.clearable"
            format="MM/dd/yyyy"
            :ui="{ input: 'font-semibold rounded-lg text-center border-stone-400 focus:border focus:border-lifeworx-blue-600 focus:ring-0 focus:outline focus:outline-3 ' }"
            :text-input="props.textInput"
            :dark="props.dark"
        >
            <template #input-icon>
                <CalendarIcon class="inline-flex mx-2 h-5 w-5 -mt-0.5 text-stone-500 input-slot-image" />
            </template>
        </VueDatePicker>
    </div>
</template>
